
import Vue from "vue";
import axios from "axios";
import swal from "sweetalert";
import themes from "devextreme/ui/themes";
import config from "./config";



export default Vue.extend({
  name: "App",

  components: {},
  methods: {
    verificarTema(){
      switch(localStorage[`Tema_${sessionStorage.Centro}`]){
        case '0':{
          this.$vuetify.theme.dark = false
          themes.current("generic.light")
          //require('../public/css/default.css')
          break;
        }
        case '1':{
          this.$vuetify.theme.dark = true
          themes.current("generic.dark")
          //require('../public/css/dark.css')
          break;
        }
       
      }
    }
  },
  computed: {
    theme() {
      return this.$vuetify.theme.dark ? "dark" : "light";
    },
  },
  async created() {
    window.onpopstate = (e: PopStateEvent)=>{
      if ((this.$router.currentRoute.path != '/' && this.$router.currentRoute.path != '/Login') && e.state == null){
        if (location.pathname != '/PreguntasFrecuentes' && location.pathname != '/InformesGenerales'){
          if (!confirm('Atención. Va a abandonar la aplicación. ¿Está seguro?')){
            e.stopImmediatePropagation()
            history.go(1)
          }
          else{
            localStorage[`Token_${sessionStorage.Centro}`] = ''
            location.href = '/'
          } 
        } 
      }
    }
    axios.interceptors.response.use(
      function(response) {
        return response;
      },
      (error) => {
        if (error.response.status === 401){
          swal(
            "Acceso Denegado",
            "La sesión ha caducado. Inicie de nuevo la sesión",
            "warning"
          ).then(()=>{
            this.$router.push("/")
          })
        }
        if (error.response.status === 403) {
          this.esCorrectoToken = false;
          axios.get(`${config.URL_API}/DataUtil/idCentro`)
            .then((res)=>{
              sessionStorage.Centro = res.data.Data
            }).then(()=>{
              localStorage[`Token_${sessionStorage.Centro}`] = "";
              this.$router.replace("/403");
            })
        }
        if (error.response.status === 500) {
          if (error.config.responseType == "arraybuffer") {
            error.response.data = String.fromCharCode.apply(
              null,
              Array.from(new Uint8Array(error.response.data))
            );
          }
          swal("ERROR " + error.response.status, error.response.data, "error");
        }
        if (error.response.status === 400) {
          if (error.response.data == '' || error.response.data == null){
            swal(
              "PETICIÓN FALLIDA",
              "\t Ocurrió un error al mandar los datos al servidor. \n "+
              "\n Recargue la página y vuelvalo a intentar, si el error persiste por favor póngase en contacto con el servicio técnico a través del correo electrónico que  "+
              "puede ver en el pié de la página describiendo con el mayor detalle bajo que condiciones se produce.",
              "error"
            );
          }
        }
        return Promise.reject(error);
      }
    );
  },
  updated(){

    document.documentElement.style.setProperty('--background-color',(this.$vuetify.theme.currentTheme.background as string))
    document.documentElement.style.setProperty('--primary-color',(this.$vuetify.theme.currentTheme.primary as string))
    document.documentElement.style.setProperty('--secondary-color',(this.$vuetify.theme.currentTheme.secondary as string))
    document.documentElement.style.setProperty('--accent-color',(this.$vuetify.theme.currentTheme.accent as string))
    document.documentElement.style.setProperty('--text-color',(this.$vuetify.theme.currentTheme.text as string))
    document.documentElement.style.setProperty('--primaryDark-color',(this.$vuetify.theme.currentTheme.primaryDark as string))
    document.documentElement.style.setProperty('--rowAlternate-color',(this.$vuetify.theme.currentTheme.rowAlternate as string))

  },
  data() {
    return {
      esCorrectoToken: false,
    };
  },
});
